export const resolveBookMediaUrl = (rawPath) => {
  if (!rawPath || typeof rawPath !== 'string') return '';
  const normalized = rawPath.replace(/\\/g, '/');
  if (/^https?:\/\//i.test(normalized)) return normalized;
  if (normalized.startsWith('/assets/')) return normalized;
  if (normalized.startsWith('extracted_assets/images/')) {
    return `/assets/images/${normalized.split('/').pop()}`;
  }
  if (normalized.startsWith('extracted_assets/tables/')) {
    return `/assets/tables/${normalized.split('/').pop()}`;
  }
  if (normalized.startsWith('/media/')) return normalized;
  return `/media/${normalized}`;
};
